import * as Sentry from '@sentry/react';

import { isProduction, window } from './globals';
import * as utils from './utils';

/**
 * Set up Sentry on our FE
 */
function initializeSentry() {
  if (!utils.isTrue(window.Sentry?.isEnabled)) {
    return;
  }

  Sentry.init({
    environment: window.Sentry.environment || 'n/a',
    release: isProduction ? window.fossa_version : window.fossa_revision,
    attachStacktrace: window.Sentry.attachStacktrace || false,
    dsn: window.Sentry.dsn,
    integrations: [
      // The Browser Tracing integration automatically instruments browser pageload/navigation actions as transactions, and captures requests, metrics and errors as spans.
      Sentry.browserTracingIntegration(),
      // This allows session replay within Sentry.
      Sentry.replayIntegration(),
      // profiling for resource intensive functions
      Sentry.browserProfilingIntegration(),
    ],

    // Tracing

    // Sample rate to determine trace sampling.
    tracesSampleRate: window.Sentry.tracesSampleRate,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // List of strings and/or Regular Expressions used to determine which outgoing requests will have sentry-trace and baggage headers attached.
    tracePropagationTargets: window.Sentry.tracePropagationTargets,

    // Session Replay

    // The sample rate for session-long replays. 1.0 will record all sessions and 0 will record none.
    replaysSessionSampleRate: window.Sentry.replaysSessionSampleRate,
    // The sample rate for sessions that has had an error occur. This is independent of sessionSampleRate. 1.0 will record all sessions and 0 will record none.
    replaysOnErrorSampleRate: window.Sentry.replaysOnErrorSampleRate,

    profilesSampleRate: window.Sentry.profilesSampleRate,
  });

  Sentry.setTag('user.id', window.user?.id ?? 'n/a');
  Sentry.setTag('user.orgId', window.user?.organizationId ?? 'n/a');
}

export default initializeSentry;
